import DetailPageLayoutTemplate from './DetailPageLayoutTemplate'

export default DetailPageLayoutTemplate
// eslint-disable-next-line import/export
export * from './DetailPageLayoutTemplate'
